module.exports = __webpack_public_path__ + "img/PAYX.ab3671c8.svg";